import _ from "lodash";
import React from "react";
import classes from "./Details.scss";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import classNames from "classnames";
import PYPElements from "UIComponents/PYPElements";
import I18nHOC from "UIComponents/I18nHOC";

import Accordian from "UIComponents/Accordian";
import {
  TaggedStudentDetails,
  UnitDetails,
  TaggedFolders,
  TaggedPracticesV2,
  SubjectJournalCard,
} from "Post/components";
import {
  getFieldList,
  getTaggableElements,
} from "modules/TaggableElementsUtils";

import { getSettingValue } from "modules/PermissionModule";
import { getElementData } from "modules/ElementValueUtils";
import {
  pypElementMapping,
  plannerElementFieldUidMap,
} from "Constants/plannerElementMappings";
import { SNPv2_ACCESS_PERMISSION } from "Constants/permissionConstants";
import {
  GoalsOutlined,
  FolderOutlined,
  ScopeAndSequenceOutlined,
  StudentAddOutlined,
  CaretOpenedFilled,
  CaretClosedFilled,
  OpenBookTextOutlined,
} from "@toddle-edu/ds-icons";
import PostCard from "Post/components/PostCard";
import { colors } from "@toddle-edu/ds-theme";
import { MediaCard } from "@toddle-edu/ds-web";
import PostRateonLearningGoals from "../../CreatePost/components/Screens/PostRateonLearningGoals";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import {
  isDPSubjectJournalEnabled,
  isPortfolioParityEnabled,
  isPortfolioReviewSetupEnabledAndIsReviewRoute,
  getIsNewGoalTaggingEnabled,
  isUnitPlanOrAssessmentTagged,
  isAssessmentTagged,
  isUnitPlanTagged,
  getPostEntityValues,
  isEvidencingRoute,
  getPostEntity,
  getIsNewGradingSetupEnabled,
  getIsStandardsRevampEnabled,
  getCurrentPlannerElementSetFromState,
  getShowNewStandardsUIInV1,
} from "AppComponents/Post/utils";
import { onEnterOrSpaceKeyDown } from "Utils";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import {
  getUserInfo,
  isPublicPlatformPostRoute,
} from "Login/modules/LoginModule";
import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import ACLStorage from "lib/aclService";
import { getIsSubjectStandard } from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/utils";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";
import { STANDARD_UIDS } from "modules/Services/ServicesConstants";

const styles = {
  subDetailContainerStyle: {
    paddingBottom: "-8px",
  },
  subDetailContainerStyleV3: {
    paddingTop: "8px",
  },
  subDetailRightContainerStyle: {
    borderRadius: "8px",
    overflow: "hidden",
    width: "40px",
    height: "40px",
  },
  detailTextStyle: {
    fontSize: "1.2rem",
    color: colors.textDefault,
  },
  detailContainerStyle: {
    padding: "0 0 16px 0",
  },
  foldersSubDetailContainer: {
    paddingTop: "8px",
  },
  postCardWidth: {
    width: "100%",
  },
  learningGoalsContainer: {
    marginTop: "0",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 500,
  },
  learningGoalsContainerDepth1: {
    marginTop: "0",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 600,
    marginBottom: "8px",
  },
  learningGoalsContainerDepth2: {
    marginTop: "0",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 500,
    marginBottom: "8px",
  },
  accordianContainerStyle: {
    paddingTop: "2px",
    paddingLeft: "4px",
  },
  titleStyle: {
    fontWeight: "600",
    fontSize: "1.4rem",
    lineHeight: "2rem",
  },
  resourceImagePlaceHolderStyle: {
    width: "48px",
    height: "48px",
    borderRadius: "8px",
  },
  detailInnerContainerStyle: {
    marginBottom: "-8px",
  },
  subDetailContainerStyleV2: {
    paddingTop: "12px",
  },
  detailContainerStyleV2: {
    paddingTop: "12px",
    paddingBottom: "8px",
  },
  assessmentContainerStyleV2: {
    paddingBottom: "8px",
    paddingTop: "0px",
  },
  unitDetailsStyle: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  accordionStyle: {
    borderBottom: "none",
    padding: "0px",
  },
  hideContainer: {
    display: "none",
  },
};

const BLANK_ARRAY = [];
const BLANK_OBJECT = {};

const TagStudentDetails = ({ taggedStudents, t, useDSV2 }) => {
  const isTagged = _.get(taggedStudents, "length", 0) > 0;

  const detailsHeaderClasses = classNames({
    [classes.detailsHeaderText]: true,
    ["text-label-l"]: !useDSV2,
    ["text-label"]: useDSV2,
  });

  return (
    <div>
      <div className={classes.separator} />
      <div className={classes.detailContainer}>
        <div className={classes.detailInnerContainer}>
          <div className={classes.iconContainer}>
            <StudentAddOutlined size={"xx-small"} />
          </div>
          <div className={detailsHeaderClasses}>
            {t("journal:tagged_students")}
          </div>
        </div>
        <div className={classes.subDetailContainer}>
          {isTagged ? (
            <TaggedStudentDetails taggedStudents={taggedStudents} />
          ) : (
            <div className={classes.detailText}>
              {t("journal:no_students_tagged")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

class Details extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPostRatingModal: false,
      isLearningGoalsViewOpen: false,
      isStandardsViewOpen: false,
    };
  }

  onCloseClick = () => {
    this.setState({ showPostRatingModal: false });
  };

  setLearningGoalsViewOpen = value => {
    this.setState({ isLearningGoalsViewOpen: value });
  };

  onAccordianDropDownClick = () => {
    const { isLearningGoalsViewOpen } = this.state;
    this.setLearningGoalsViewOpen(!isLearningGoalsViewOpen);
  };

  onStandardsViewOpen = value => {
    this.setState({ isStandardsViewOpen: value });
  };

  onStandardsAccordianDropDownClick = () => {
    const { isStandardsViewOpen } = this.state;
    this.onStandardsViewOpen(!isStandardsViewOpen);
  };

  render() {
    const {
      detail,
      elementData,
      toggleMediaModal,
      onCloseClick,
      fullMedia,
      taggedStudents,
      t,
      onPostActionClick,
      userId,
      postId,
      showTagSnpV2,
      showTagSnP,
      userType,
      showCloseBtn,
      toggleCommentBox,
      toggleLEPreview,
      detailsContainerStyle,
      mediaMaxWidth,
      mediaMaxHeight,
      attachmentContainerStyle,
      hideViews,
      hideLike,
      hideComments,
      hideLearninGoals,
      hideUnitDetails,
      hideTaggedStudents,
      showTaggedFolders,
      taggableElements,
      courseIdFromQuery,
      portfolioStudentId,
      selectFromAllPYP,
      showPracticeStatus,
      showPypElements,
      onJournalPostActionClick,
      showDownloadBeginOverlay,
      isSidePaneContent = true,
      isViewFromPostPage = false,
      childId,
      curriculumProgramType,
      theatreActiveAttachmentIndex,
      setTheatreAttachmentIndex,
      theatreActiveAttachmentId,
      showAttachmentAsMediaCard = false,
      setTheatreAttachmentById,
      isRightPaneCard,
      openedFromNotification,
      fromPropsActivitySelectedStudentId,
      fromPropsHandleActivitySelectedStudentAttachmentsChange,
      staffEditAccess = true,
      cardType,
      canEditOrDelete,
      hideMoveToDraftOption,
      defaultAccodianExpanded,
      isProjectPostCard = false,
      canAddComments = true,
      customTextStyle,
      customContainerStyle = {},
      openMediaOnLoad,
      showLeAndUnitDetailsV2 = false,
      hasManageAccess,
      showRoutineDetails,
      postTaggedEntity,
      hasRoutinesManageAccess,
      useDSV2,
      commentContainerClass,
      postCardStyles,
      isLearningCourseEnabled,
      isViewFromUnitPlanReflection,
      standardLabel,
    } = this.props;

    const isWorkSheetTagged = _.some(
      postTaggedEntity,
      entity => _.get(entity, "entity.assessmentType.value") === "worksheet"
    );
    const { isLearningGoalsViewOpen, isStandardsViewOpen } = this.state;
    const ratedStudents =
      userType == "parent" || userType == "student"
        ? [
            _.find(
              taggedStudents || [],
              student =>
                _.get(student, "node.id", "") ==
                (userType == "parent" ? childId : userId)
            ),
          ]
        : [...(taggedStudents || [])];
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
    const {
      unitPlan,
      resourceItem,
      resourceType,
      folders,
      title: postTitle,
      practices,
      taggedPractices: taggedPractices,
    } = detail;

    const hasElementData = _.some(elementData, element => {
      return !_.isEmpty(element);
    });

    const showLearningGoals = hasElementData && !_.isEmpty(elementData);

    const setShowPostRatingModal = value => {
      this.setState({ showPostRatingModal: value });
    };

    const iconContainerStyle = {
      width: "32px",
      height: "32px",
      justifyContent: "center",
      borderRadius: "4px",
    };

    const dynamicLevelContainerStyle = {
      0: {
        color: colors.textDefault,
        fontWeight: 600,
      },
      1: {
        color: colors.textDefault,
      },
      3: {
        color: colors.textSubtle,
      },
    };

    const dynamicLevelContainerStyleV2 = {
      0: styles.learningGoalsContainer,
      1: styles.learningGoalsContainer,
      2: styles.learningGoalsContainer,
      3: {
        color: colors.textSubtle,
        paddingLeft: "16px",
        ...styles.learningGoalsContainer,
      },
    };

    const standardsDynamicLevelContainerStyleV2 = {
      0: styles.learningGoalsContainer,
      1: styles.learningGoalsContainerDepth1,
      2: styles.learningGoalsContainerDepth2,
      3: {
        paddingLeft: "16px",
        ...styles.learningGoalsContainer,
      },
    };

    const childrenContainerStyle = [
      { style: { gridRowGap: "16px" }, depth: 0 },
    ];

    const onPostRateOnLearningGoalsCardClick = e => {
      showNewTheatreMode()
        ? _.isFunction(setTheatreAttachmentById)
          ? setTheatreAttachmentById({
              type: "POST_RATED_LEARNING_GOALS",
              elementPYPOfRatings: _.get(detail, "elementPYP", []),
              propsIbPypElementRatings: _.get(
                detail,
                "ibPYPElementRatings",
                []
              ),
            })
          : setShowPostRatingModal(true)
        : setShowPostRatingModal(true);
    };

    const handlePostRateOnLEKeyDown = e =>
      onEnterOrSpaceKeyDown(e, onPostRateOnLearningGoalsCardClick);

    const isJournalRoute = hasIncludeGivenPathInCurrentRoute({
      path: "/journal",
    });

    const isRoutineRoute = hasIncludeGivenPathInCurrentRoute({
      path: "/routines",
    });

    const isStudentFeedRoute = hasIncludeGivenPathInCurrentRoute({
      path: "/studentFeed",
    });

    const isFamilyPortfolioRoute = hasIncludeGivenPathInCurrentRoute({
      path: "/family-portfolio-summary",
    });
    const isEvidencing = isEvidencingRoute();

    const showPortfolioParityCard =
      isPortfolioParityEnabled() &&
      (isJournalRoute ||
        isRoutineRoute ||
        isFamilyPortfolioRoute ||
        isStudentFeedRoute ||
        isPortfolioReviewSetupEnabledAndIsReviewRoute());
    const handleAccordianKeyDown = e =>
      onEnterOrSpaceKeyDown(e, this.onAccordianDropDownClick);
    const isPublicRoute =
      isPublicPlatformPostRoute() ||
      _.includes(window.location.href, "platform/links/post");

    const updatedPostTaggedEntity = isAssessmentTagged(postTaggedEntity)
      ? getPostEntityValues(postTaggedEntity, "ASSESSMENT")
      : postTaggedEntity;
    const isSingleUnitTagged =
      _.size(getPostEntity(postTaggedEntity, "UNIT_PLAN")) === 1;

    const iconContainerStyleV2 = {
      ...iconContainerStyle,
      backgroundColor: colors.blue950,
    };

    const detailsHeaderClasses = classNames({
      [classes.detailsHeaderText]: true,
      ["text-label-l"]: !useDSV2,
      ["text-label"]: useDSV2,
    });

    const tagCardTitleClasses = classNames({
      [classes.tagCardTitle]: true,
      ["text-label-l"]: !useDSV2,
      ["text-label"]: useDSV2,
    });

    const showStandardsView =
      (getIsNewGradingSetupEnabled() &&
        !isUnitPlanOrAssessmentTagged(postTaggedEntity) &&
        getIsStandardsRevampEnabled() &&
        isLearningCourseEnabled) ||
      (getShowNewStandardsUIInV1() &&
        !isLearningCourseEnabled &&
        !isUnitPlanOrAssessmentTagged(postTaggedEntity));

    const filteredTaggableElements = _.filter(
      taggableElements,
      item => !getIsSubjectStandard({ type: item?.elementType })
    );

    const filteredStandards = _.filter(taggableElements, item =>
      getIsSubjectStandard({
        type: item?.elementType,
      })
    );

    const isOtherGoalTagged =
      _.size(
        _.filter(
          _.keys(elementData),
          key => !getIsSubjectStandard({ type: pypElementMapping[key] })
        )
      ) > 0;

    const isStandardElementPresent =
      _.size(
        _.filter(_.keys(elementData), key =>
          getIsSubjectStandard({ type: pypElementMapping[key] })
        )
      ) > 0;
    return (
      <div className={classes.container} style={detailsContainerStyle}>
        {(!isDPSubjectJournalEnabled(curriculumProgramType) &&
          !isProjectPostCard) ||
        showPortfolioParityCard ? (
          <PostCard
            item={detail}
            onPostActionClick={onPostActionClick}
            onCloseClick={onCloseClick}
            userId={userId}
            canEditOrDelete={canEditOrDelete}
            isSidePaneContent={isSidePaneContent}
            containerStyle={styles.postCardWidth}
            portfolioStudentId={portfolioStudentId}
            showCloseBtn={showCloseBtn}
            toggleCommentBox={toggleCommentBox}
            isViewFromPostPage={isViewFromPostPage}
            mediaMaxWidth={mediaMaxWidth}
            theatreActiveAttachmentIndex={theatreActiveAttachmentIndex}
            setTheatreAttachmentIndex={setTheatreAttachmentIndex}
            theatreActiveAttachmentId={theatreActiveAttachmentId}
            showAttachmentAsMediaCard={showAttachmentAsMediaCard}
            setTheatreAttachmentById={setTheatreAttachmentById}
            hideCommentBox={true}
            isTheatreView={true}
            staffEditAccess={staffEditAccess}
            hideLike={hideLike}
            hideViews={hideViews}
            hideComments={hideComments}
            hideLearninGoals={hideLearninGoals}
            hideTaggedStudents={hideTaggedStudents}
            hideUnitDetails={hideUnitDetails}
            showTaggedFolders={showTaggedFolders}
            fromPropsActivitySelectedStudentId={
              fromPropsActivitySelectedStudentId
            }
            fromPropsHandleActivitySelectedStudentAttachmentsChange={
              fromPropsHandleActivitySelectedStudentAttachmentsChange
            }
            openedFromNotification={openedFromNotification}
            sourceType={_.get(this.props, "sourceType")}
            cardType={cardType}
            toggleLEPreview={toggleLEPreview}
            openMediaOnLoad={openMediaOnLoad}
            canCreateComment={canAddComments}
            hasManageAccessForStudentPortfolio={hasManageAccess}
            showRoutineDetails={showRoutineDetails}
            isProjectPostCard={isProjectPostCard}
            hasRoutinesManageAccess={hasRoutinesManageAccess}
            useDSV2={useDSV2}
            commentContainerClass={commentContainerClass}
            postCardStyles={postCardStyles}
            isViewFromUnitPlanReflection={isViewFromUnitPlanReflection}
            learningCourseIdFromProps={_.get(
              detail,
              "course.learningCourse[0].id",
              null
            )}
          >
            {hideTaggedStudents || userType === "parent"
              ? null
              : !_.isEmpty(taggedStudents) && (
                  <TagStudentDetails
                    t={t}
                    taggedStudents={taggedStudents}
                    useDSV2={useDSV2}
                  />
                )}

            {hideUnitDetails ||
            selectFromAllPYP ||
            !showPypElements ? null : !_.isEmpty(unitPlan) &&
              !isPublicRoute &&
              !isNewGoalTaggingEnabled ? (
              <UnitDetails
                unitPlan={unitPlan}
                resourceItem={resourceItem}
                resourceType={resourceType}
                showIcon={true}
                detailContainerStyle={styles.detailContainerStyle}
                subDetailContainerStyle={styles.subDetailContainerStyle}
                subDetailRightContainerStyle={
                  styles.subDetailRightContainerStyle
                }
                detailTextStyle={styles.detailTextStyle}
                iconContainerStyle={iconContainerStyleV2}
                iconVariant={"link"}
                showResourceItem={false}
                userType={userType}
                canAddWorksheetResponseToPost={isWorkSheetTagged}
              />
            ) : (
              !_.isEmpty(postTaggedEntity) &&
              isNewGoalTaggingEnabled &&
              !showLeAndUnitDetailsV2 &&
              isUnitPlanOrAssessmentTagged(updatedPostTaggedEntity) &&
              !isPublicRoute && (
                <div>
                  <div className={classes.separator} />
                  <div className={classes.detailContainer}>
                    {!_.isEmpty(postTaggedEntity) && _.isArray(postTaggedEntity)
                      ? _.map(
                          isAssessmentTagged(postTaggedEntity)
                            ? getPostEntityValues(
                                postTaggedEntity,
                                isPublicRoute || isEvidencing
                                  ? "UNIT_PLAN"
                                  : "ASSESSMENT"
                              )
                            : postTaggedEntity,
                          (entity, index) => {
                            const entityType = _.get(entity, "entityType", "");
                            const isUnitPlan = _.isEqual(
                              entityType,
                              "UNIT_PLAN"
                            );
                            return (
                              <UnitDetails
                                unitPlan={_.get(entity, "entity", null)}
                                resourceItem={
                                  !isUnitPlan
                                    ? _.get(entity, "entity", null)
                                    : null
                                }
                                resourceType={_.get(entity, "entityType")}
                                showIcon={index === 0}
                                showDetailsHeaderText={index === 0}
                                detailContainerStyle={
                                  styles.detailContainerStyle
                                }
                                subDetailContainerStyle={
                                  styles.subDetailContainerStyleV3
                                }
                                subDetailRightContainerStyle={
                                  styles.subDetailRightContainerStyle
                                }
                                detailTextStyle={styles.detailTextStyle}
                                iconContainerStyle={iconContainerStyleV2}
                                iconVariant={"link"}
                                showResourceItem={false}
                                userType={userType}
                                canAddWorksheetResponseToPost={
                                  isWorkSheetTagged
                                }
                              />
                            );
                          }
                        )
                      : null}
                  </div>
                </div>
              )
            )}
            {showLeAndUnitDetailsV2 &&
            !isProjectPostCard &&
            showPypElements &&
            (_.size(elementData) ||
              !_.isEmpty(unitPlan) ||
              !_.isEmpty(resourceItem) ||
              (!_.isEmpty(postTaggedEntity) &&
                isUnitPlanOrAssessmentTagged(postTaggedEntity))) ? (
              <div style={{ paddingBottom: "8px" }}>
                <div className={classes.separator} />
                <div
                  className={classes.detailContainer}
                  style={styles.detailContainerStyleV2}
                >
                  <div className={classes.detailInnerContainer}>
                    <div
                      className={classes.iconContainer}
                      style={{ backgroundColor: colors.teal950 }}
                    >
                      <OpenBookTextOutlined
                        size={"xx-small"}
                        variant="success"
                      />
                    </div>
                    <div className={detailsHeaderClasses}>
                      {t("journal:tagged_learning_elements")}
                    </div>
                  </div>
                  {isNewGoalTaggingEnabled &&
                  !isAssessmentTagged(postTaggedEntity) &&
                  isUnitPlanTagged(postTaggedEntity) ? (
                    <div
                      className={classNames({
                        "text-label-l": !useDSV2,
                        "text-label": useDSV2,
                      })}
                    >
                      {isSingleUnitTagged
                        ? t("common:unit")
                        : t("journal:units")}
                    </div>
                  ) : null}
                  {!_.isEmpty(postTaggedEntity) &&
                  isNewGoalTaggingEnabled &&
                  isUnitPlanOrAssessmentTagged(postTaggedEntity) ? (
                    _.map(updatedPostTaggedEntity, (entity, i) => {
                      const entityType = _.get(entity, "entityType", "");
                      const isUnitPlan = _.isEqual(entityType, "UNIT_PLAN");
                      const isResourceItem = _.isEqual(
                        entityType,
                        "ASSESSMENT"
                      );
                      return (
                        <>
                          {" "}
                          <div style={styles.unitDetailsStyle}>
                            {isUnitPlanOrAssessmentTagged(postTaggedEntity) ? (
                              <UnitDetails
                                unitPlan={
                                  isUnitPlan
                                    ? _.get(entity, "entity", null)
                                    : isResourceItem
                                    ? _.get(entity, "entity.unitPlan")
                                    : null
                                }
                                resourceItem={
                                  !isUnitPlan
                                    ? _.get(entity, "entity", null)
                                    : null
                                }
                                resourceType={_.get(entity, "entityType")}
                                subDetailContainerStyle={
                                  styles.subDetailContainerStyleV2
                                }
                                subDetailRightContainerStyle={
                                  styles.subDetailRightContainerStyle
                                }
                                detailTextStyle={styles.detailTextStyle}
                                iconContainerStyle={iconContainerStyleV2}
                                showDesignV2={true}
                                showDetailsHeaderText={false}
                                showUnitPlan={
                                  !isAssessmentTagged(postTaggedEntity)
                                }
                                detailInnerContainerStyle={
                                  styles.detailInnerContainerStyle
                                }
                                resourceImagePlaceHolderStyle={
                                  styles.resourceImagePlaceHolderStyle
                                }
                                userType={userType}
                                canAddWorksheetResponseToPost={
                                  isWorkSheetTagged
                                }
                                useDSV2={useDSV2}
                              />
                            ) : null}
                          </div>
                        </>
                      );
                    })
                  ) : !_.isEmpty(unitPlan) || !_.isEmpty(resourceItem) ? (
                    <UnitDetails
                      unitPlan={unitPlan}
                      resourceItem={resourceItem}
                      resourceType={resourceType}
                      subDetailContainerStyle={styles.subDetailContainerStyleV2}
                      subDetailRightContainerStyle={
                        styles.subDetailRightContainerStyle
                      }
                      detailTextStyle={styles.detailTextStyle}
                      iconContainerStyle={{
                        ...iconContainerStyle,
                        backgroundColor: colors.blue950,
                      }}
                      showDesignV2={true}
                      showDetailsHeaderText={false}
                      showUnitPlan={!resourceItem}
                      detailInnerContainerStyle={
                        styles.detailInnerContainerStyle
                      }
                      resourceImagePlaceHolderStyle={
                        styles.resourceImagePlaceHolderStyle
                      }
                      userType={userType}
                      canAddWorksheetResponseToPost={isWorkSheetTagged}
                    />
                  ) : null}
                </div>
                {_.size(elementData) ? (
                  showStandardsView ? (
                    <>
                      {isOtherGoalTagged ? (
                        <div
                          className={tagCardTitleClasses}
                          onClick={this.onAccordianDropDownClick}
                          data-test-id="journal-feed-learninggoalstoggle-button"
                          onKeyDown={handleAccordianKeyDown}
                        >
                          {t("journal:edit_post_pyp_elements")}
                          <span style={styles.accordianContainerStyle}>
                            {isLearningGoalsViewOpen ? (
                              <CaretOpenedFilled
                                tabIndex={0}
                                className={classes.focusIcon}
                                size={"xxx-small"}
                              />
                            ) : (
                              <CaretClosedFilled
                                tabIndex={0}
                                className={classes.focusIcon}
                                size={"xxx-small"}
                              />
                            )}
                          </span>
                        </div>
                      ) : null}
                      <Accordian
                        hideContainerBorder={true}
                        showLabelBorder={false}
                        isExpanded={isLearningGoalsViewOpen}
                        expandedContent={
                          <PYPElements
                            elementData={elementData}
                            showInAccordian={false}
                            pypTemplateElements={filteredTaggableElements}
                            dynamicLevelContainerStyle={
                              isPortfolioParityEnabled()
                                ? dynamicLevelContainerStyleV2
                                : dynamicLevelContainerStyle
                            }
                            customTitleStyle={styles.titleStyle}
                            theme={{ labelStyle: styles.titleStyle }}
                            childrenContainerStyle={childrenContainerStyle}
                            addSeparators={true}
                            itemContainerClass={classes.PYPElementPadding}
                            defaultAccodianExpanded={defaultAccodianExpanded}
                            customTextStyle={styles.learningGoalsContainer}
                            customContainerStyle={styles.accordionStyle}
                            showDesignV2={showPortfolioParityCard}
                            showDPLpaInTextView={true}
                            showStandardsLabel={getIsNewGradingSetupEnabled()}
                            standardLabel={standardLabel}
                          />
                        }
                        showLeftArrow={true}
                        customTitleComponent={null}
                        headerStyle={styles.hideContainer}
                        shouldStopPropagation={true}
                      />
                      {isStandardElementPresent ? (
                        <div
                          className={tagCardTitleClasses}
                          onClick={this.onStandardsAccordianDropDownClick}
                          data-test-id="journal-feed-learninggoalstoggle-button"
                        >
                          {standardLabel ?? t("common:standard_plural")}
                          <span style={styles.accordianContainerStyle}>
                            {isStandardsViewOpen ? (
                              <CaretOpenedFilled
                                tabIndex={0}
                                className={classes.focusIcon}
                                size={"xxx-small"}
                              />
                            ) : (
                              <CaretClosedFilled
                                tabIndex={0}
                                className={classes.focusIcon}
                                size={"xxx-small"}
                              />
                            )}
                          </span>
                        </div>
                      ) : null}
                      <Accordian
                        hideContainerBorder={true}
                        showLabelBorder={false}
                        isExpanded={isStandardsViewOpen}
                        expandedContent={
                          <PYPElements
                            elementData={elementData}
                            showInAccordian={false}
                            pypTemplateElements={filteredStandards}
                            dynamicLevelContainerStyle={
                              isPortfolioParityEnabled()
                                ? standardsDynamicLevelContainerStyleV2
                                : dynamicLevelContainerStyle
                            }
                            customTitleStyle={styles.titleStyle}
                            theme={{ labelStyle: styles.titleStyle }}
                            childrenContainerStyle={childrenContainerStyle}
                            addSeparators={true}
                            itemContainerClass={classes.PYPElementPadding}
                            defaultAccodianExpanded={defaultAccodianExpanded}
                            customTextStyle={styles.learningGoalsContainer}
                            customContainerStyle={styles.accordionStyle}
                            showDesignV2={showPortfolioParityCard}
                            showDPLpaInTextView={true}
                            showStandardsLabel={getIsNewGradingSetupEnabled()}
                            showDiscAtAllLevel={true}
                            hideLabel={true}
                            standardLabel={standardLabel}
                          />
                        }
                        showLeftArrow={true}
                        customTitleComponent={null}
                        headerStyle={styles.hideContainer}
                        shouldStopPropagation={true}
                      />
                    </>
                  ) : (
                    <div
                      className={tagCardTitleClasses}
                      onClick={this.onAccordianDropDownClick}
                      data-test-id="journal-feed-learninggoalstoggle-button"
                      onKeyDown={handleAccordianKeyDown}
                    >
                      {t("journal:edit_post_pyp_elements")}
                      <span style={styles.accordianContainerStyle}>
                        {isLearningGoalsViewOpen ? (
                          <CaretOpenedFilled
                            tabIndex={0}
                            className={classes.focusIcon}
                          />
                        ) : (
                          <CaretClosedFilled
                            tabIndex={0}
                            className={classes.focusIcon}
                          />
                        )}
                      </span>
                    </div>
                  )
                ) : null}
                {!showStandardsView ? (
                  <Accordian
                    hideContainerBorder={true}
                    showLabelBorder={false}
                    isExpanded={isLearningGoalsViewOpen}
                    expandedContent={
                      <PYPElements
                        elementData={elementData}
                        showInAccordian={false}
                        pypTemplateElements={taggableElements}
                        dynamicLevelContainerStyle={
                          isPortfolioParityEnabled()
                            ? dynamicLevelContainerStyleV2
                            : dynamicLevelContainerStyle
                        }
                        customTitleStyle={styles.titleStyle}
                        theme={{ labelStyle: styles.titleStyle }}
                        childrenContainerStyle={childrenContainerStyle}
                        addSeparators={true}
                        itemContainerClass={classes.PYPElementPadding}
                        defaultAccodianExpanded={defaultAccodianExpanded}
                        customTextStyle={styles.learningGoalsContainer}
                        customContainerStyle={styles.accordionStyle}
                        showDesignV2={showPortfolioParityCard}
                        showDPLpaInTextView={true}
                        showStandardsLabel={true}
                        standardLabel={standardLabel}
                      />
                    }
                    showLeftArrow={true}
                    customTitleComponent={null}
                    headerStyle={styles.hideContainer}
                    shouldStopPropagation={true}
                  />
                ) : null}
              </div>
            ) : null}
            {isPublicRoute &&
            _.size(postTaggedEntity) &&
            _.isUndefined(theatreActiveAttachmentIndex) &&
            isUnitPlanOrAssessmentTagged(postTaggedEntity) ? (
              <div
                className={classes.detailContainer}
                style={styles.assessmentContainerStyleV2}
              >
                {isAssessmentTagged(postTaggedEntity) ? (
                  <UnitDetails
                    unitPlan={
                      _.size(postTaggedEntity) > 1
                        ? _.get(postTaggedEntity, `[1].entity`, null)
                        : null
                    }
                    resourceItem={_.first(postTaggedEntity)?.entity || null}
                    resourceType={_.get(
                      _.first(postTaggedEntity),
                      "entityType"
                    )}
                    subDetailRightContainerStyle={
                      styles.subDetailRightContainerStyle
                    }
                    detailTextStyle={styles.detailTextStyle}
                    iconContainerStyle={iconContainerStyleV2}
                    showDesignV2={true}
                    showDetailsHeaderText={false}
                    showUnitPlan={!isAssessmentTagged(postTaggedEntity)}
                    detailInnerContainerStyle={styles.detailInnerContainerStyle}
                    resourceImagePlaceHolderStyle={
                      styles.resourceImagePlaceHolderStyle
                    }
                    userType={userType}
                    canAddWorksheetResponseToPost={isWorkSheetTagged}
                  />
                ) : (
                  _.map(
                    getPostEntityValues(postTaggedEntity, "UNIT_PLAN"),
                    (entity, index) => {
                      return (
                        <UnitDetails
                          unitPlan={_.get(entity, "entity", null)}
                          resourceItem={null}
                          resourceType={_.get(entity, "entityType")}
                          subDetailRightContainerStyle={
                            styles.subDetailRightContainerStyle
                          }
                          detailTextStyle={styles.detailTextStyle}
                          iconContainerStyle={iconContainerStyleV2}
                          showDesignV2={false}
                          showIcon={true}
                          showDetailsHeaderText={true}
                          showUnitPlan={!isAssessmentTagged(postTaggedEntity)}
                          detailInnerContainerStyle={
                            styles.detailInnerContainerStyle
                          }
                          resourceImagePlaceHolderStyle={
                            styles.resourceImagePlaceHolderStyle
                          }
                          userType={userType}
                          canAddWorksheetResponseToPost={isWorkSheetTagged}
                        />
                      );
                    }
                  )
                )}
              </div>
            ) : null}
            {hideLearninGoals || !showPypElements
              ? null
              : showLearningGoals && (
                  <div>
                    {!showLeAndUnitDetailsV2 ? (
                      <div className={classes.separator} />
                    ) : null}
                    <div
                      className={classes.detailContainer}
                      style={{
                        paddingTop: showLeAndUnitDetailsV2 ? "0px" : "",
                      }}
                    >
                      {!showLeAndUnitDetailsV2 ? (
                        <div className={classes.detailInnerContainer}>
                          <div
                            className={classes.iconContainer}
                            style={{ backgroundColor: colors.teal950 }}
                          >
                            <GoalsOutlined
                              size={"xx-small"}
                              variant="success"
                            />
                          </div>
                          <div className={detailsHeaderClasses}>
                            {t("journal:tagged_pyp_elements")}
                          </div>
                        </div>
                      ) : null}
                      <div className={classes.pypElementsContainer}>
                        {!showLeAndUnitDetailsV2 ? (
                          <PYPElements
                            elementData={elementData}
                            pypTemplateElements={taggableElements}
                            dynamicLevelContainerStyle={
                              dynamicLevelContainerStyle
                            }
                            childrenContainerStyle={childrenContainerStyle}
                            showInAccordian={true}
                            addSeparators={true}
                            itemContainerClass={classes.PYPElementPadding}
                            defaultAccodianExpanded={defaultAccodianExpanded}
                            customTextStyle={customTextStyle}
                            customContainerStyle={customContainerStyle}
                            standardLabel={standardLabel}
                          />
                        ) : null}
                        {_.size(detail.elementPYP, 0) > 0 &&
                          _.size(this.props.ibPypElementRatings, 0) > 0 && (
                            <div
                              tabIndex={0}
                              onKeyDown={handlePostRateOnLEKeyDown}
                              className={classes.postLearningGoalsMediaCard}
                            >
                              <MediaCard
                                cardType="medium"
                                type={"LEARNING GOALS"}
                                name={t("common:teacher_evaluation")}
                                showSubtext={true}
                                onClick={onPostRateOnLearningGoalsCardClick}
                                isActivated={this.state.showPostRatingModal}
                              />
                            </div>
                          )}
                        {this.state.showPostRatingModal && (
                          <PostRateonLearningGoals
                            students={ratedStudents}
                            elementPYP={detail.elementPYP}
                            curriculumProgramType={_.get(
                              this.props,
                              "curriculumProgramType",
                              CURRICULUM_TYPE_PYP
                            )}
                            showLearningGoalsEditor={false}
                            onCloseClick={this.onCloseClick}
                            mode={"create"}
                            showLearningGoalsPreview={true}
                            setShowPostRatingsModal={
                              this.setShowPostRatingModal
                            }
                            propsIbPypElementRatings={
                              this.props.ibPypElementRatings
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
            {showTaggedFolders &&
              showPypElements &&
              !_.isEmpty(folders) &&
              !showPortfolioParityCard && (
                <div>
                  <div className={classes.separator} />
                  <div className={classes.detailContainer}>
                    {!isDPSubjectJournalEnabled(curriculumProgramType) ? (
                      <div className={classes.detailInnerContainer}>
                        <div
                          className={classes.iconContainer}
                          style={{ backgroundColor: colors.pink950 }}
                        >
                          <FolderOutlined
                            size={"xx-small"}
                            variant="critical"
                          />
                        </div>
                        <div className={detailsHeaderClasses}>
                          {t("journal:tagged_folders")}
                        </div>
                      </div>
                    ) : null}
                    <div
                      className={classes.subDetailContainer}
                      style={styles.foldersSubDetailContainer}
                    >
                      <TaggedFolders
                        folders={folders}
                        showFolderIcon={true}
                      ></TaggedFolders>
                    </div>
                  </div>
                </div>
              )}
            {showTagSnP && !_.isEmpty(practices) && (
              <div>
                <div className={classes.separator} />
                <div className={classes.detailContainer}>
                  <div className={classes.detailInnerContainer}>
                    <div
                      className={classes.iconContainer}
                      style={{ backgroundColor: colors.surfaceSubtle }}
                    >
                      <ScopeAndSequenceOutlined size={"xx-small"} />
                    </div>
                    <div className={detailsHeaderClasses}>
                      {showPortfolioParityCard
                        ? t("journal:tagged_standards_practices")
                        : t("journal:tagged_practices")}
                    </div>
                  </div>
                  <div className={classes.subDetailContainer}>
                    <TaggedPracticesV2
                      taggedPractices={taggedPractices}
                      showPracticeStatus={showPracticeStatus}
                      postTitle={postTitle}
                      showFilledStarIcon={!showPortfolioParityCard}
                    />
                  </div>
                </div>
              </div>
            )}
            {showTagSnpV2 && !_.isEmpty(taggedPractices) && (
              <div>
                <div className={classes.separator} />
                <div className={classes.detailContainer}>
                  <div className={classes.detailInnerContainer}>
                    <div
                      className={classes.iconContainer}
                      style={{ backgroundColor: colors.surfaceSubtle }}
                    >
                      <ScopeAndSequenceOutlined size={"xx-small"} />
                    </div>
                    <div className={detailsHeaderClasses}>
                      {showPortfolioParityCard
                        ? t("journal:tagged_standards_practices")
                        : t("journal:tagged_practices")}
                    </div>
                  </div>
                  <div className={classes.subDetailContainer}>
                    <TaggedPracticesV2
                      taggedPractices={taggedPractices}
                      showPracticeStatus={showPracticeStatus}
                      postTitle={postTitle}
                      showFilledStarIcon={!showPortfolioParityCard}
                    />
                  </div>
                </div>
              </div>
            )}
          </PostCard>
        ) : (
          <React.Fragment>
            <SubjectJournalCard
              post={detail}
              onPostActionClick={onPostActionClick}
              userId={userId}
              canEditOrDelete={canEditOrDelete}
              showCommentButton={_.get(this.props, "showCommentButton", false)}
              showCloseBtn={showCloseBtn}
              isViewFromPostPage={isViewFromPostPage}
              onCloseClick={onCloseClick}
              isRightPaneCard={isRightPaneCard}
              isSidePaneContent={isSidePaneContent}
              setTheatreAttachmentIndex={setTheatreAttachmentIndex}
              theatreActiveAttachmentId={theatreActiveAttachmentId}
              setTheatreAttachmentById={setTheatreAttachmentById}
              showAttachmentAsMediaCard={showAttachmentAsMediaCard}
              openedFromNotification={openedFromNotification}
              sourceType={_.get(this.props, "sourceType")}
              hideComments={hideComments}
              hideLike={hideLike}
              hideViews={hideViews}
              cardType={cardType}
              hideMoveToDraftOption={hideMoveToDraftOption}
              isProjectPostCard={isProjectPostCard}
              canAddComments={canAddComments}
              openMediaOnLoad={openMediaOnLoad}
              hasManageAccessForStudentPortfolioFromProps={hasManageAccess}
            />
            {showTagSnpV2 && !_.isEmpty(taggedPractices) && (
              <div>
                <div className={classes.separator} />
                <div className={classes.detailContainer}>
                  <div
                    className={classes.detailInnerContainer}
                    style={{
                      padding: "0px 8px 8px",
                    }}
                  >
                    <div
                      className={classes.iconContainer}
                      style={{ backgroundColor: colors.surfaceSubtle }}
                    >
                      <ScopeAndSequenceOutlined size={"xx-small"} />
                    </div>
                    <div className={detailsHeaderClasses}>
                      {showPortfolioParityCard
                        ? t("journal:tagged_standards_practices")
                        : t("journal:tagged_practices")}
                    </div>
                  </div>
                  <div
                    className={classes.subDetailContainer}
                    style={{ padding: "16px" }}
                  >
                    <TaggedPracticesV2
                      taggedPractices={taggedPractices}
                      showPracticeStatus={showPracticeStatus}
                      postTitle={postTitle}
                      showFilledStarIcon={!showPortfolioParityCard}
                    />
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapActionCreators = {};

const mapStateToProps = (state, ownProps) => {
  const currentUnitPlanId = _.get(state, "planner.unitPlanData.unitPlanId");
  const userInfo = getUserInfo();
  const userType = userInfo.user_type;
  const unitPlan = _.get(ownProps.detail, "unitPlan", BLANK_OBJECT);
  const postTaggedEntity = _.get(
    ownProps.detail,
    "postTaggedEntity",
    BLANK_OBJECT
  );

  const subjects = _.get(unitPlan, "subjects.value", BLANK_ARRAY);
  let grades = _.get(unitPlan, "grades", BLANK_ARRAY);
  const elementPYP = _.get(ownProps.detail, "elementPYP", BLANK_ARRAY);

  const ibPypElementRatings =
    userType == "student"
      ? _.filter(
          _.get(ownProps.detail, "ibPYPElementRatings", BLANK_ARRAY),
          rating => _.get(rating, "student.id") == userInfo.id
        )
      : _.get(ownProps.detail, "ibPYPElementRatings", BLANK_ARRAY);

  const taggedBenchmarksValue = _.get(
    _.find(elementPYP, item => item.fieldUID == "benchmarks"),
    "value",
    BLANK_ARRAY
  );
  const selectedGrades = state.teacher?.selected_class?.selected_grades;
  let selectFromAllPYP = false;
  if (
    (!_.isEmpty(elementPYP) &&
      _.isEmpty(unitPlan) &&
      !getIsNewGoalTaggingEnabled()) ||
    (!_.isEmpty(elementPYP) &&
      _.isEmpty(postTaggedEntity) &&
      getIsNewGoalTaggingEnabled())
  )
    selectFromAllPYP = true;

  if (selectFromAllPYP) grades = selectedGrades;

  let curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    _.get(ownProps, "detail.curriculumProgram.type")
  );
  if (_.isNil(curriculumProgramType))
    curriculumProgramType = _.get(ownProps, "detail.curriculumProgram.type");

  const isSnpV2Enabled = ACLStorage.getModuleSettingsValue(
    SNPv2_ACCESS_PERMISSION
  );

  const orgId = userInfo.org_id;
  // if showPypElements is false, then we will hide the Tagged Folders, Learning Goals, and Unit Details
  const showPypElements =
    userType !== "parent"
      ? true
      : getSettingValue({
          name: "ShowPypElementInFamilyApp",
          organizationId: orgId,
        });

  const showTagSnpV2 = isSnpV2Enabled;
  const plannerElementSets = _.get(
    state,
    "platform.currentPlannerElementSets",
    BLANK_ARRAY
  );

  const childId = userType == "parent" ? userInfo.childID : undefined;

  const showCommentButton =
    !_.get(ownProps, "hideComments", false) &&
    (userType === "staff" ||
      getSettingValue({
        name:
          userType === "parent"
            ? "enableFamilyCommentCreation"
            : "EnableCommentingOnPostByStudents",
        courseId: _.get(state, "teacher.selected_class.selected_course"),
        organizationId: userInfo.org_id,
        userId: userInfo.id,
        userEntityType: userInfo.userEntityType,
      }));

  const isLearningCourseEnabled = getIsLearningCoursesEnabled(state);

  const standardLabel = _.get(
    getCurrentPlannerElementSetFromState(
      _.get(
        plannerElementFieldUidMap,
        _.get(STANDARD_UIDS, curriculumProgramType)
      )
    )(state),
    "label",
    "Standards"
  );

  return {
    isData: true,
    showLoaderBar: false,
    isLoading: false,
    userType: userInfo.user_type,
    organizationId: orgId,
    showPypElements,
    portfolioStudentId: ownProps?.portfolioStudentId,
    elementData: getElementData({
      isPost: true,
      elements: elementPYP,
      // unitPlanFields: unitPlanFields,
      field_list: getFieldList({ curriculumProgramType }),
      deriveSubjectIdsFromNodes: true,
      skipRemoveSubjectCheck: getIsNewGradingSetupEnabled(),
    }),
    elementPYP: elementPYP,
    selectFromAllPYP,
    grades,
    subjects,
    taggedBenchmarksValue,
    unitPlan,
    showTagSnpV2,
    ibPypElementRatings,
    taggableElements: getTaggableElements({
      curriculumProgramType,
      unitPlan,
      plannerElementSets,
    }),
    childId,
    curriculumProgramType,
    showCommentButton,
    postTaggedEntity,
    isLearningCourseEnabled,
    standardLabel,
  };
};

const ComposedDetailComponent = compose(
  I18nHOC({ resource: "journal" }),
  connect(mapStateToProps, mapActionCreators)
)(Details);

ComposedDetailComponent.defaultProps = {
  hideLearninGoals: false,
  hideTaggedStudents: false,
  hideUnitDetails: false,
  showTaggedFolders: true,
};

export default ComposedDetailComponent;
Details.displayName = "Details";
